import DataTable, {
    Caption,
    TBody,
    THead
} from '../../../../components/DataTable'
import { RowError } from './hooks/types'
import { TableImportProps } from './types'

function sortRowErrors(rowsError: RowError[]): RowError[] {
    const withoutRow = rowsError.filter(err => !isRow(err))
    const withRow = rowsError
        .filter(isRow)
        .sort((a, b) => Number(a.index) - Number(b.index))
    return [...withoutRow, ...withRow]
}

function isRow(err: RowError): boolean {
    return err.index !== null && err.index !== undefined
}

export default function TableImport({ rowsError }: TableImportProps) {
    return (
        <DataTable>
            <THead>
                <tr>
                    <th>#</th>
                    <th>Fila</th>
                    <th>Detalle</th>
                </tr>
            </THead>
            <TBody>
                {sortRowErrors(rowsError).map((err, i) => (
                    <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{isRow(err) ? err.index : 'Archivo'}</td>
                        <td
                            style={{ whiteSpace: 'normal' }}
                            className={
                                err.severity === 'warning'
                                    ? 'text-warning'
                                    : 'text-error'
                            }
                        >
                            {err.message}
                        </td>
                    </tr>
                ))}
                {rowsError.length === 0 && <Caption colSpan={3}>---</Caption>}
            </TBody>
        </DataTable>
    )
}
